<template>
    <div class="loader">
        <div class="loader__content">
            <icon class="loader__icon" size="2em" name="loader" :animation="{name:'rotate', duration: '1.5s', repeat:'infinite'}" />
            <ul v-if="displayStatus" class="loader__text loader__text--data">
                <li v-for="(percentage, type) in displayStatus" :key="type" class="loader__row">
                    <div class="loader__value">
                        {{percentage}}%
                    </div>
                    <div class="loader__label">
                        {{resource(type)}}
                    </div>
                </li>
            </ul>
            <div v-else class="loader__text loader__text--placeholder">{{resource('syncing')}}</div>
        </div>
    </div>
</template>
<style lang="scss">
.loader{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background:$overlay;
    z-index: 1337;
    &__content{
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: $h1;
    }
    &__text{
        text-shadow: 0 0 5px #000, 0 0 15px #000;
        &--placeholder{
             font-weight: bold;
        }
        &--data{
            font-size: $fs;
            list-style: none;
            padding:0;
            margin:0;
        }
    }
    &__icon{
        margin-bottom: $content;
    }
    &__row{
        display: flex;
    }
    &__value{
        width: 50px;
    }
}
</style>
<script>
import { EventBus } from './../event-bus'
export default {
	name: 'loaderOverlay',
	created(){
		let $this = this
		EventBus.$on('loadingStatus', item => {
			$this.$set(this.status, item.type, item.loadingPercentage)
		})
	},
	methods:{
		resource(item){
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
	},
	computed:{
		displayStatus(){
			if(Object.keys(this.status).length){
				return this.status
			}
			return null
		}
	},
	data(){
		return{
			res:{
				nl:{
					syncing: 'Synchroniseren...',
					downloadProducts: 'Downloaden producten',
					downloadClients: 'Downloaden retailers',
					clientsIndex: 'Retailers indexeren',
					productsIndex: 'Producten indexeren',
					brandsIndex: 'Merken indexeren',
					subBrandsIndex: 'Submerken indexeren',
					categoriesIndex: 'Categorieën indexeren',
					subCategoriesIndex: 'Subcategorieën indexeren',
					subSubCategoriesIndex: 'Subsubcategorieën indexeren',
					subSubSubCategoriesIndex: 'Subsubsubcategorieën indexeren',
					initClients: 'Initialisatie klanten',
					initProducts: 'Initialisatie producten'
				},
				fr:{
					syncing: 'Synchroniser...',
					downloadProducts: 'Télécharger des produits',
					downloadClients: 'Télécharger les revendeurs',
					clientsIndex: 'Index détaillants',
					productsIndex: 'Index des produits',
					brandsIndex: 'Index marques',
					subBrandsIndex: 'Index sous-marques',
					categoriesIndex: 'Indexation des catégories',
					subCategoriesIndex: 'Sous-catégories d\'index',
					subSubCategoriesIndex: 'Index sous-sous-catégories',
					subSubSubCategoriesIndex: 'Sous-sous-catégories d\'index',
					initClients: 'Clients d\'initialisation',
					initProducts: 'Produits d\'initialisation'
				}
			},
			status: {}
		}
	}
}
</script>
